import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

export default function Footer() {
  const s = useSettings();
  return (
    <footer className="foot">
      <div className="wrap fgrid">
        <div>
          <h4>{s.brand}</h4>
          <p>We are an air charter broker. We arrange flights as your agent; every flight is operated by an operator holding a Non-Scheduled Operator Permit from India's Directorate General of Civil Aviation (DGCA), which has operational control of the aircraft.</p>
          <p style={{ marginTop: 10 }}>
            {s.phone ? <>Call: <a href={`tel:${s.phone}`}>{s.phone}</a><br /></> : null}
            {s.email ? <>Email: <a href={`mailto:${s.email}`}>{s.email}</a><br /></> : null}
            {s.whatsapp ? <>WhatsApp: <a href={`https://wa.me/${s.whatsapp.replace(/\\D/g, "")}`} target="_blank" rel="noopener noreferrer">{s.whatsapp}</a></> : null}
          </p>
        </div>
        <div>
          <h4>Explore</h4>
          <p><Link to="/fleet">Our fleet</Link></p>
          <p><Link to="/how-it-works">How it works</Link></p>
          <p><Link to="/about">About</Link></p>
          <p><Link to="/contact">Contact</Link></p>
        </div>
        <div>
          <h4>About the figures</h4>
          <p>Aircraft specifications are typical published values, rounded. Seats, range and times vary with the aircraft's layout, load and weather. Fleet numbers come from the DGCA non-scheduled operator list of 31.08.2026. All flights are subject to availability and a confirmed quote.</p>
          <p><Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link></p>
          <p style={{ marginTop: 8 }}><Link to="/login">Admin login</Link></p>
        </div>
      </div>
    </footer>
  );
}
